const en = {

    title: {
        content : "Senior Fullstack Developer"
    },
    bio: {
        content_1: "Hi, I'm Diego. I build software for a living.",
        content_2: "For 10+ years I've been making web apps for companies that need faster, clearer tools for their daily work.",
        content_3: "I like working on products people actually use.",
        content_4: "The kind that saves the team work and that users get without a manual.",
        content_5: "I've worked with companies of all sizes, in healthcare, education, tourism and HRTech, and learned a ton from the teams along the way.",
        content_6: "These days I work with AI-assisted development and Spec-Driven Development: I pin down what needs to be built first, then use Claude Code and Cursor to ship it faster and with fewer bugs.",
        content_7: "I try to get tech to do one thing: solve the problem without creating a new one.",
        content_8: "A good app works the way it should, every single day. (That's enough to make me happy.)",
        content_9: "Here are some of the projects and experiences that got me here."
    },
    descriptionHyperlinks: {
        content_1: ''
    },
    hyperlinks : {
        content_0: "{DEV 101} \n Invaluable Tips to Boost Your Dev Career",
        content_1: "Career",
        content_2: "Portfolio",
        content_3: "Site web",
        content_4: "X (Twitter)",
        content_5: "Contact Me",
    }
};

export default en;
